// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  credentialsKeys: {
    user: 'user',
    token: 'token',
    databaseName: 'databasename',
    dataAutenticacao: 'dataautenticacao',
    isAutoAtendimento: 'isautoatendimento',
    baseUrl: 'baseurl',
    numeroCaixa: 'numeroCaixa',
    nomeTerminal: 'nomeTerminal',
    whatsappResponsavel: 'whatsappResponsavel',
    whatsappEmpresa: 'whatsappEmpresa',
    dispositivoId: 'dispositivoId',
  },
  solicitarSenhaSomentePrimeiraVez: 'solicitarSenhaSomentePrimeiraVez',
  baseUrlQrCode: 'baseUrlQrCode',
  version: 'v1.0.029',
  milisegundosAtualizacaoTelaDeliveryKey: 'milisegundosAtualizacaoTelaDelivery'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
